import cn from 'classnames';

import Text from 'components/common/Text';
import Tag from 'components/icons/illustrative/DiscountTag';
import { HOME_CHEF } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const DiscountTag = ({
  discountText,
  spanClassNames = '',
  brandStylesOverrides = '',
  textClassName = '',
  flex = true,
}) => {
  const isHomeChef = useBrand(HOME_CHEF);

  return (
    <Text
      brandStylesOverrides={brandStylesOverrides}
      htmlElement="span"
      className={cn(spanClassNames, 'mr-1 h-7 items-center rounded-2xl py-2 pl-2 pr-3', {
        'bg-green-50': isHomeChef,
        'bg-tempo-blue-50': !isHomeChef,
        flex: flex,
      })}
    >
      <Tag svgSize={ICON_SIZES.SM} className="text-primary pr-0.5" />
      <Text
        htmlElement="span"
        className={`${textClassName} inline-block`}
        brandStylesOverrides="textSm"
      >
        {discountText}
      </Text>
    </Text>
  );
};

DiscountTag.propTypes = {
  discountText: PropTypes.string,
  spanClassNames: PropTypes.string,
  textClassName: PropTypes.string,
  brandStylesOverrides: PropTypes.string,
  flex: PropTypes.bool,
};

export default DiscountTag;
